import { FC, useMemo } from 'react'
import { Card, Form, InputNumber, Typography } from 'antd'
import { useForm, useWatch } from 'antd/es/form/Form'
import { calcRibbonRollsNeededPreview } from '../../../../helpers/calculations/calc-ribbon-rolls'

interface CalculatorFormValues {
    labelLength?: number
    labelGap?: number
    labelsPerRoll?: number
    labelRollsCount?: number
    ribbonLength?: number
}

const RibbonRollsCalculator: FC = () => {
    const [form] = useForm<CalculatorFormValues>()

    const labelLength = useWatch('labelLength', form)
    const labelGap = useWatch('labelGap', form)
    const labelsPerRoll = useWatch('labelsPerRoll', form)
    const labelRollsCount = useWatch('labelRollsCount', form)
    const ribbonLength = useWatch('ribbonLength', form)

    const rollsNeeded = useMemo(
        () =>
            calcRibbonRollsNeededPreview({
                labelLength: labelLength || 0,
                labelGap: labelGap || 0,
                labelsPerRoll: labelsPerRoll || 0,
                labelRollsCount: labelRollsCount || 0,
                ribbonLength: ribbonLength || 0,
            }),
        [labelLength, labelGap, labelsPerRoll, labelRollsCount, ribbonLength]
    )

    return (
        <Card title='Калькулятор рулонов риббона' size='small' style={{ marginBottom: 16 }}>
            <Form
                form={form}
                layout='inline'
                initialValues={{ labelGap: 0, labelRollsCount: 1 }}
                style={{ rowGap: 12 }}
            >
                <Form.Item name='labelLength' label='Длина этикетки'>
                    <InputNumber min={0} style={{ width: 120 }} />
                </Form.Item>
                <Form.Item name='labelGap' label='м/э'>
                    <InputNumber min={0} style={{ width: 100 }} />
                </Form.Item>
                <Form.Item name='labelsPerRoll' label='Этикеток в рулоне'>
                    <InputNumber min={1} style={{ width: 120 }} />
                </Form.Item>
                <Form.Item name='labelRollsCount' label='Рулонов этикеток'>
                    <InputNumber min={1} style={{ width: 120 }} />
                </Form.Item>
                <Form.Item name='ribbonLength' label='Длина риббона'>
                    <InputNumber min={0.001} style={{ width: 120 }} />
                </Form.Item>
            </Form>
            <Typography.Title level={4} style={{ marginTop: 16, marginBottom: 0 }}>
                Нужно рулонов риббона: {rollsNeeded}
            </Typography.Title>
        </Card>
    )
}

export default RibbonRollsCalculator
